
import { STATUS } from "@interfaces/enum";

const getStatus = function (status, type = "bg") {
    let color = "";
    switch (status) {
        case STATUS.PENDING:
        case STATUS.UNPAID:
        case STATUS.FOR_APPROVAL:
        case STATUS.SUSPENDED:
        case STATUS.INACTIVE:
        case STATUS.OTHERS:
            color = "warning";
            break;
        case STATUS.SERVED:
        case STATUS.ACTIVATED:
        case STATUS.PAID:
        case STATUS.DONE:
        case STATUS.ACTIVE:
        case STATUS.LABORATORY:    
            color = "success";
            break;
        case STATUS.ACCEPTED:
        case STATUS.APPROVED:
        case STATUS.CONSULTATION:
            color = "primary";
            break;
        case STATUS.CANCELLED:
        case STATUS.DECLINED:
        case STATUS.EXPIRED:
        case STATUS.FAILED:
        case STATUS.FOR_DELETION:
            color = "danger";
            break;
        case STATUS.ON_GOING:
        case STATUS.REFUNDED:
        case STATUS.DELETED:
        case STATUS.BOUNCED:    
        case STATUS.TRANSACTION_PENDING:
            color = "dark";
            break;
        case STATUS.ON_HOLD:
        case STATUS.RESCHEDULE:
        case STATUS.SENT:
        case STATUS.TELECONSULTATION:
            color = "info";
            break;
        case STATUS.QUEUED:
            color = "secondary";
            break;
        default:
            break;
    }
    return `${type}-${color}`;
}

const getPaymentTypeColor = function (status, type = "bg") {
    let color = "";
    switch (status) {
        case 'debit/credit':
            color = "primary";
            break;
        case 'free':
            color = "success";
            break;
        case 'hmo':
            color = "warning";
            break;
        default:
            color = "dark";
            break;
    }
    return `${type}-${color}`;
}

const auditsItems = function (data) {
    const new_data = data.new_values;
    const old_data = data.old_values;
    const last_new = new_data ? new_data[new_data.length - 1] : "";
    const last_old = old_data ? old_data[old_data.length - 1] : "";
    
    let diffItems = [];
    if ((last_new=="}" || last_new=="]") && (last_old=="}" || last_old=="]")) {
        const new_values = JSON.parse(new_data);
        const old_values = JSON.parse(old_data);
        for (const key in new_values) {
            const new_value = _.replace(new_values[key], " 00:00:00", "");
            const old_value = _.replace(old_values[key], " 00:00:00", "");
            let invalidKeys = [
                "updated_by",
                "created_by",
                "updated_at",
                "created_at"
            ];
            if (new_value != old_value && !_.includes(invalidKeys, key)) {
                let info = {
                    key: key.replace(/_/g, " "),
                    new_value,
                    old_value
                };
                diffItems.push(info);
            }
        }
    }
    return diffItems;
}

const getUserTypes = function (label) {
    let color = "";
    switch (label) {
        case 'doctor':
            color = "primary";
            
            break;
        case 'dentist':
            color = "info";
            break;
        case 'tm_user':
            color = "warning";
            break;
        case 'patient':
            color = "success";
            break;
        case 'pharmacist':
            color = "indigo";
            break;
        default:
            color = "dark";
            break;
    }
    return {
        color,
        label: _.startCase(_.toLower(label))
    };
}

export default {
    getStatus,
    auditsItems,
    getPaymentTypeColor,
    getUserTypes
}